import Stack, { StackProps } from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { upperFirst } from 'lodash';
import * as Device from 'react-device-detect';

export interface FormHeaderProps extends StackProps {
  type: 'booking' | 'event';
  action: 'create' | 'edit';
  startDate: moment.Moment;
  isDateClosed: boolean;
  handleClose: () => void;
}

export const FormHeader = (props: FormHeaderProps) => {
  const { type, action, startDate, isDateClosed, handleClose } = props;
  const { t } = useTranslation('cta');
  const theme = useTheme();

  const titleMap = {
    create: {
      booking: t('add a booking'),
      event: t('add an event'),
    },
    edit: {
      booking: t('edit booking'),
      event: t('edit event'),
    },
  };

  const title = titleMap[action][type];

  return (
    <AppBar position={Device.isMobileOnly ? 'fixed' : 'sticky'} elevation={0}>
      <Toolbar
        sx={{
          px: 0,
          justifyContent: 'space-between',
        }}
      >
        <Stack alignItems="space-between" sx={{ pl: 1 }}>
          <Typography variant="subtitle2" align="center" color="textSecondary">
            {upperFirst(title)}
          </Typography>
          <Typography variant="subtitle2" align="left" fontSize="0.7rem" color="textPrimary">
            {moment(startDate).format('LLLL').split(' ').slice(0, -1).join(' ')}
          </Typography>
        </Stack>
        <Stack direction="row">
          <IconButton aria-label="close" onClick={handleClose}>
            <theme.icons.close />
          </IconButton>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
